<template>
  <div>
    <TitleBar>
      <template v-slot:title>{{ getTitle }}</template>
    </TitleBar>
    <div class="content">
      <p class="description-text">{{ getDescription }}</p>
      <router-view></router-view>
    </div>
  </div>
</template>
  <script>
import TitleBar from '@/components/TitleBar'

export default {
  name: 'Ledger',
  components: { TitleBar },
  computed: {
    getTitle () {
      let title = ''
      if (this.$route.name === 'Ledger') {
        title = this.$gettext('Cost categories')
      } else {
        title = this.$gettext('Ledger categories')
      }
      return title
    },
    getDescription() {
      let description = ''
      if (this.$route.name === 'Ledger') {
        description = this.$gettext('These cost types will be seen by all your customers and they will be able to book their receipts on these entries. If you want to hide cost types, archive them. If you want to manage cost types per customer, you have to go to your customers local account.')
      } else {
        description = this.$gettext('Ledgers are only used for internal use and not visible to your customers. You can use this to indicate the different types of receipts (e.g. "investments" vs "expenses") or group multiple cost types in one overarching ledger.')
      }
      return description
    },
  },
  methods: {

  },
}
</script>
  <style lang="scss" scoped>
.content {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 20px;
}
.description-text {
  color: $colorTextSemi;
  padding-top: 20px;
  padding-bottom: 15px;
}
</style>
  <style lang="scss">
.content {
  .nav-tabs .nav-link:hover,
  .nav-tabs .nav-link:focus {
    border-color: #ffffff00 !important;
  }
}
.active-tab {
  border-bottom: 2px solid $colorBrand;
  a {
    color: $colorTextSemi !important;
  }
}
.disabled-tab {
  a {
    color: $colorUnassigned !important;
  }
}
</style>